/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import Select from 'react-select'
import {
  getServiceT006,
  putServiceT006,
  getNaturalSolList,
  getServingList,
  getAnchorsList,
  getPositionnementList,
  getChargementList,
  getPositionMatList,
} from '../../core/prestation/request'
import {useSelector} from 'react-redux'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../../../auth'
import {toast} from 'react-toastify'
import {ListeServiceStatus, PutT006} from '../../core/prestation/model'
import {Button, Modal} from 'react-bootstrap'
import * as lodash from 'lodash'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'
import {Color} from '../../../../../common/components/Constants/colors.constants'

// const initialTBForm6Values = {
//   MB500Selected: true,
//   NatureOfGroundSupport: '',
//   NatureOfGroundSupportOther: '',
//   Swivel: true,
//   MatePosition: '',
//   Positioning: '',
//   Servings: '',
//   ServingsOther: '',
//   Anchors: '',
//   AnchorsOther: '',
//   SoilLoading: '',
//   UnloadingOnFloors: '',
//   IsThefacadeAsbestos: '',
//   AnyCladdingOnTheFacade: '',
// }
type ToggleButtonForm6Props = {
  isVisible5: boolean
  onDetectChange6?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t006?: ListeServiceStatus
}

const ToggleButtonForm6: FC<ToggleButtonForm6Props> = ({
  isVisible5,
  onDetectChange6,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  onSavedForm,
  t006,
  loadListServiceStatus,
}) => {
  const {mode, modeSelect} = useThemeMode()
  const intl = useIntl()
  const [surfaceSelect, setSurfaceSelect] = useState<any>(null)
  const [surfaceOption, setSurfaceOption] = useState<any>(null)
  const [servingSelect, setServingSelect] = useState<any>(null)
  const [servingOption, setServingOption] = useState<any>(null)
  const [anchorsSelect, setAnchorsSelect] = useState<any>(null)
  const [anchorsOption, setAnchorsOption] = useState<any>(null)
  const {setAuthMessage, logout} = useAuth()
  const [serviceT006, setServiceT006] = useState<any>(null)
  const [soilLoading, setSoilLoading] = useState<string[] | any[]>([])
  const [unloadingOnFloors, setUnloadingOnFloors] = useState<string[] | any[]>([])
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [loading, setLoading] = useState<boolean>(true)
  const [t1init, setT1init] = useState<any>(null)
  const [inputChange, setInputChange] = useState<any>(false)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [dropdownData, setDropdownData] = useState<any[]>([])
  const [dropdownChargementDataTB, setDropdownChargementDataTB] = useState<any[]>([])
  //console.log('setSurfaceOption', surfaceOption)
  const [dropdownChargementDataPM, setDropdownChargementDataPM] = useState<any[]>([])

  const [isEchafaudage, setAnchorSelection] = useState<any>(null)

  // const onRefreshListeService6 = () => {
  //   const services: any[] = [...listeService]
  //   const data = services.find((item) => item === itemProps)
  //   if (data) {
  //     const index = services.findIndex((item) => item === itemProps)
  //     if (index === -1) {
  //       //return
  //     }
  //     services.splice(index, 1, {...itemProps, Completed: true})
  //     setServiceData(itemProps)
  //     setListService(services)
  //   }
  // }

  const onAccessLost = (message: string) => {
    setAuthMessage(message)
    logout()
  }

  const loadServiceT006 = async () => {
    const response = await getServiceT006(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT006(response?.data?.data)
      if (response?.data?.data?.SoilLoading) {
        const soilData: string[] =
          response?.data?.data?.SoilLoading.split(',').map((data: string) => data.trim()) || []
        setSoilLoading(soilData)
      }
      if (response?.data?.data?.UnloadingOnFloors) {
        const _unloadingOnFloors: string[] =
          response?.data?.data?.UnloadingOnFloors.split(',').map((data: string) => data.trim()) ||
          []
        setUnloadingOnFloors(_unloadingOnFloors)
      }
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }

  const loadNaturalSolList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    let wsObjRes: any = null
    if (Guid) {
      wsObjRes = await getNaturalSolList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (wsObjRes?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(wsObjRes?.data?.Status?.Message)
        return
      }
      if (wsObjRes && wsObjRes?.data?.data) {
        const _surfaceSolOptions: any[] = (wsObjRes?.data?.data || []).map((surface: any) => ({
          ...surface,
          value: surface?.Guid,
          label: surface?.Name,
        }))
        setSurfaceOption(_surfaceSolOptions)
        const _surface = _surfaceSolOptions.find(
          (option: any) => option?.Guid === serviceT006?.NatureOfGroundSupport
        )
        if (_surface) {
          setSurfaceSelect(_surface)
        } else {
          setSurfaceSelect(null)
        }
      }
    }
    setLoading(false)
  }

  const loadServingList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    //let wsObjRes: any = null
    if (Guid) {
      const response = await getServingList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (response?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(response?.data?.Status?.Message)
        return
      }
      if (response && response?.data?.data) {
        const _servingOptions: any[] = (response?.data?.data || []).map((ns: any) => ({
          ...ns,
          value: ns?.Guid,
          label: ns?.Name,
        }))

        setServingOption(_servingOptions)
        const _serving = _servingOptions.find(
          (option: any) => option?.Guid === serviceT006?.Servings
        )
        if (_serving) {
          setServingSelect(_serving)
        } else setServingSelect(null)
      }
    }
    setLoading(false)
  }

  const loadAnchorsList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    if (Guid) {
      const response = await getAnchorsList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (response?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(response?.data?.Status?.Message)
        return
      }
      if (response && response?.data?.data) {
        const _anchorsOptions: any[] = (response?.data?.data || []).map((ns: any) => ({
          ...ns,
          value: ns?.Guid,
          label: ns?.Name,
        }))

        setAnchorsOption(_anchorsOptions)
        const _anchors = _anchorsOptions.find(
          (option: any) => option?.Guid === serviceT006?.Anchors
        )
        if (_anchors) {
          setAnchorSelection(_anchors.Code)
          setAnchorsSelect(_anchors)
        } else setAnchorsSelect(null)
      }
    }
    setLoading(false)
  }

  const loadPositionnementList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    //let wsObjRes: any = null
    if (Guid) {
      const response = await getPositionnementList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (response?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(response?.data?.Status?.Message)
        return
      }
      if (response?.data?.data && Array.isArray(response?.data?.data)) {
        setDropdownData(response?.data?.data ?? [])
      }
    }
    setLoading(false)
  }

  const loadPositionMatList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    //let wsObjRes: any = null
    if (Guid) {
      const response = await getPositionMatList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (response?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(response?.data?.Status?.Message)
        return
      }
      if (response?.data?.data && Array.isArray(response?.data?.data)) {
        setDropdownChargementDataPM(response?.data?.data ?? [])
      }
    }
    setLoading(false)
  }

  const loadChargementList = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    //let wsObjRes: any = null
    if (Guid) {
      const response = await getChargementList(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (response?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(response?.data?.Status?.Message)
        return
      }
      if (response?.data?.data && Array.isArray(response?.data?.data)) {
        setDropdownChargementDataTB(response?.data?.data ?? [])
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    loadServiceT006()
  }, [])

  useEffect(() => {
    const load = async () => {
      await loadNaturalSolList()
      await loadPositionnementList()
      await loadPositionMatList()
      await loadServingList()
      await loadAnchorsList()
      await loadChargementList()
    }
    if (t1init != null) load()
  }, [t1init])

  const handleClickT006 = async () => {
    try {
      if (serviceT006) {
        const dataToUpdate: PutT006 = {
          ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
          NatureOfGroundSupport: serviceT006?.NatureOfGroundSupport,
          NatureOfGroundSupportOther: serviceT006?.NatureOfGroundSupportOther,
          Swivel: serviceT006?.Swivel,
          MatePosition: serviceT006?.MatePosition,
          Positioning: serviceT006?.Positioning,
          Servings: serviceT006?.Servings,
          ServingsOther: serviceT006?.ServingsOther,
          Anchors: serviceT006?.Anchors,
          AnchorsOther: serviceT006?.AnchorsOther,
          SoilLoading: serviceT006?.SoilLoading,
          UnloadingOnFloors: serviceT006?.UnloadingOnFloors,
          IsThefacadeAsbestos: serviceT006?.IsThefacadeAsbestos,
          AnyCladdingOnTheFacade: serviceT006?.AnyCladdingOnTheFacade,
        }
        console.log('Data to update:', serviceT006)

        const response = await putServiceT006(dataToUpdate)
        if (response?.data?.Status?.Success) {
          if (onSavedForm) {
            onSavedForm(true)
          }
          // if(loadListServiceStatus) {
          //   loadListServiceStatus()
          // }
        }
        await loadServiceT006()
        if (loadListServiceStatus) await loadListServiceStatus()
      } else {
        console.log("serviceT006 n'est pas encore prêt.")
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des données :", error)
      toast.error("Une erreur s'est produite lors de l'enregistrement des données")
    }
  }

  const handleSelectSurfaceChange = (surface: any) => {
    if (surface) {
      setSurfaceSelect(surface)
      setServiceT006({
        ...serviceT006,
        NatureOfGroundSupport: surface?.value,
        NatureOfGroundSupportOther: '',
      })
    } else {
      setSurfaceSelect(null)
      setServiceT006({
        ...serviceT006,
        NatureOfGroundSupport: null,
        //NatureOfGroundSupportOther: surface?.value,
      })
    }
  }

  const handleSelectServingChange = (serving: any) => {
    if (serving) {
      setServingSelect(serving)
      setServiceT006({
        ...serviceT006,
        Servings: serving.value,
        ServingsOther: '',
      })
    } else {
      setServingSelect(null)
      setServiceT006({
        ...serviceT006,
        Servings: null,
      })
    }
  }
  const handleSelectAnchorsChange = (anchors: any) => {
    if (anchors) {
      setAnchorsSelect(anchors)
      setAnchorSelection(anchors.Code)
      setServiceT006({
        ...serviceT006,
        Anchors: anchors.value,
        AnchorsOther: '',
      })
    } else {
      if (anchors) {
        setAnchorsSelect(null)
        setServiceT006({
          ...serviceT006,
          Anchors: null,
        })
      }
    }
  }
  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await handleSelectSurfaceChange(null)
      await setServingSelect(null)
      await setAnchorsSelect(null)
      await setSoilLoading([])
      await setUnloadingOnFloors([])
      await setServiceT006(null)
      await setT1init(null)
      await loadServiceT006()
      setShowCancel(false)
    } else {
      await setSurfaceSelect(null)
      await setServingSelect(null)
      await setAnchorsSelect(null)
      await setSoilLoading([])
      await setUnloadingOnFloors([])
      await setServiceT006(null)
      await setT1init(null)
      await loadServiceT006()
      setShowCancel(false)
    }
  }
  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT006, t1init)
  }, [serviceT006, t1init])

  useEffect(() => {
    if (onDetectChange6) {
      onDetectChange6(isDisabled)
    }
  }, [isDisabled, onDetectChange6])

  const onChangeSoilLoading = (checked: boolean, index: number, item: any) => {
    if (checked) {
      setSoilLoading((prevState) => {
        const _soilLoading = [...prevState]
        _soilLoading.push(item?.Guid)
        setServiceT006({...serviceT006, SoilLoading: _soilLoading.toString()})
        return _soilLoading
      })
    } else {
      setSoilLoading((prevState) => {
        let _soilLoading = [...prevState]
        _soilLoading = _soilLoading.filter((data) => data !== item?.Guid)
        setServiceT006({...serviceT006, SoilLoading: _soilLoading.toString()})
        return _soilLoading
      })
    }
  }
  const onChangeUnloadingOnFloors = (checked: boolean, index: number, item: any) => {
    console.log(item)
    if (checked) {
      setUnloadingOnFloors((prevState) => {
        const _unloadingOnFloors = [...prevState]
        _unloadingOnFloors.push(item?.Guid)
        setServiceT006({...serviceT006, UnloadingOnFloors: _unloadingOnFloors.toString()})
        return _unloadingOnFloors
      })
    } else {
      setUnloadingOnFloors((prevState) => {
        let _unloadingOnFloors = [...prevState]
        _unloadingOnFloors = _unloadingOnFloors.filter((data) => data !== item?.Guid)
        setServiceT006({...serviceT006, UnloadingOnFloors: _unloadingOnFloors.toString()})
        return _unloadingOnFloors
      })
    }
  }

  return (
    <div>
      {isVisible5 && (
        <div className='d-flex flex-column'>
          <form>
            <div className='p-5 mt-8'>
              <div className='d-flex justify-content-between mb-5'>
                <div
                  style={{flex: 10}}
                  className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1'
                >
                  <div style={{flex: 0.4}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'GROUND_SURFACE_TYPE'})}
                    </label>
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                  <div style={{flex: 0.6}}>
                    <div>
                      <Select
                        options={surfaceOption}
                        className='form-select-solid custom-select mb-3'
                        value={surfaceSelect}
                        onChange={handleSelectSurfaceChange}
                        styles={modeSelect}
                        isDisabled={Submitted}
                      />
                    </div>
                    <div className='d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row'>
                      <label className='fs-6 text-gray-700 me-2'>
                        {intl.formatMessage({id: 'OTHER'})}
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        value={serviceT006?.NatureOfGroundSupportOther ?? ''}
                        disabled={Submitted}
                        onChange={(e) => {
                          setServiceT006({
                            ...serviceT006,
                            NatureOfGroundSupport: null,
                            NatureOfGroundSupportOther: e.target?.value ?? '',
                          })
                          setSurfaceSelect(null)
                          //setInputChange(true)
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className='justify-content-end'>{/*<CenterHelp />*/}</div>
              </div>
              {serviceT006?.MB500Selected === true ? (
                <div
                  style={{flex: 10}}
                  className='gap-1 align-items-center  justify-content-xl-between justify-content-lg-between d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row flex-1'
                >
                  <div style={{flex: 0.4}}>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'PIVOTONG'})}
                    </label>
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                  <div className='d-flex gap-20 my-3' style={{flex: 0.65}}>
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'YES'})}
                      checked={serviceT006?.Swivel === true}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT006({...serviceT006, Swivel: true})
                      }}
                    />
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'NO'})}
                      checked={serviceT006?.Swivel === false}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT006({...serviceT006, Swivel: false})
                      }}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
              {(serviceT006?.Swivel === false && serviceT006?.MB500Selected === true) ||
              serviceT006?.MB500Selected === false ? (
                <div
                  style={{flex: 10}}
                  className='gap-1 align-items-center  justify-content-xl-between justify-content-lg-between d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row flex-1'
                >
                  <div style={{flex: 0.4}}>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'MATE_POSITION'})}
                    </label>
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                  <div className='d-flex gap-16 my-3' style={{flex: 0.65}}>
                    {dropdownChargementDataPM.map((MP, index) => (
                      <RadioButton
                        classNameContainer='d-flex gap-3  align-items-center'
                        label={MP?.Name}
                        checked={serviceT006?.MatePosition === MP?.Guid}
                        classNameCheckedActive=''
                        classNameCheckedInactive=''
                        classNameDefaultLabel=''
                        handleClick={() => {
                          setServiceT006({...serviceT006, MatePosition: MP?.Guid ?? ''})
                        }}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                ''
              )}
              {serviceT006?.MB500Selected !== true ? (
                <div
                  style={{flex: 10}}
                  className='gap-1 align-items-center  justify-content-xl-between justify-content-lg-between d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row flex-1'
                >
                  <div style={{flex: 0.4}}>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'POSITIONING'})}
                    </label>
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                  <div className='d-flex gap-12 my-3' style={{flex: 0.65}}>
                    {dropdownData.map((option, index) => (
                      <RadioButton
                        classNameContainer='d-flex gap-3  align-items-center'
                        label={option?.Name}
                        checked={serviceT006?.Positioning === option?.Guid}
                        classNameCheckedActive=''
                        classNameCheckedInactive=''
                        classNameDefaultLabel=''
                        handleClick={() => {
                          setServiceT006({...serviceT006, Positioning: option?.Guid ?? ''})
                        }}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                ''
              )}

              <div
                style={{flex: 10}}
                className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'
              >
                <div style={{flex: 0.4}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'SERVINGS'})}
                  </label>
                  ({' '}
                  <i className='fa fa-star-of-life text-danger' style={{fontSize: 10, top: -5}}></i>{' '}
                  )
                </div>
                <div style={{flex: 0.6}} className='pe-14'>
                  <div>
                    <Select
                      options={servingOption}
                      className='form-select-solid custom-select mb-3'
                      value={servingSelect}
                      onChange={handleSelectServingChange}
                      styles={modeSelect}
                      isDisabled={Submitted}
                    />
                  </div>
                  <div className='d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row'>
                    <label className='fs-6 text-gray-700 me-2'>
                      {intl.formatMessage({id: 'OTHER'})}
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      value={serviceT006?.ServingsOther ?? ''}
                      disabled={Submitted}
                      onChange={(e) => {
                        setServiceT006({
                          ...serviceT006,
                          Servings: null,
                          ServingsOther: e.target.value,
                        })
                        setServingSelect(null)
                        //setInputChange(true)
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{flex: 10}}
                className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1'
              >
                <div style={{flex: 0.4}}>
                  <div className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'ANCHORS'})}
                    </label>
                    {isEchafaudage === 'ECHAFAUDAGE' ? (
                      <p style={{marginTop: '10px', color: 'red'}}>
                        {intl.formatMessage({id: 'MESSAGE_ANCHORS'})}
                      </p>
                    ) : (
                      <p style={{marginTop: '10px', color: 'black'}}>
                        {intl.formatMessage({id: 'INFO_ANCHORS'})}
                      </p>
                    )}
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                </div>
                <div style={{flex: 0.6}} className='pe-14'>
                  <div>
                    <Select
                      options={anchorsOption}
                      className='form-select-solid custom-select mb-3'
                      value={anchorsSelect}
                      isDisabled={Submitted}
                      onChange={handleSelectAnchorsChange}
                      styles={modeSelect}
                    />
                  </div>
                  <div className='d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row'>
                    <label className='fs-6 text-gray-700 me-2'>
                      {intl.formatMessage({id: 'OTHER'})}
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      value={serviceT006?.AnchorsOther ?? ''}
                      disabled={Submitted}
                      onChange={(e) => {
                        setServiceT006({
                          ...serviceT006,
                          Anchors: null,
                          AnchorsOther: e.target.value ?? '',
                        })
                        setAnchorsSelect(null)
                        //setInputChange(true)
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{flex: 10}}
                className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'
              >
                <div style={{flex: 0.4}}>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'GROUND_LOADING'})}
                  </label>
                  ({' '}
                  <i className='fa fa-star-of-life text-danger' style={{fontSize: 10, top: -5}}></i>{' '}
                  )
                </div>
                <div className='d-flex gap-10 my-3' style={{flex: 0.6}}>
                  {dropdownChargementDataTB.map((option, index) => {
                    console.log(
                      'soilLoading.includes(options?.Guid)',
                      soilLoading.includes(option?.Guid?.trim())
                    )
                    return serviceT006?.MB500Selected === false ||
                      (serviceT006?.MB500Selected === true && option?.Name !== 'Latéral') ? (
                      <div key={index} className='d-flex gap-3 align-items-center'>
                        <input
                          className={'form-check-input fs-3 '}
                          type='checkbox'
                          onChange={async (e) => {
                            const checked = e.target.checked
                            onChangeSoilLoading(checked, index, option)
                          }}
                          checked={soilLoading?.includes(option?.Guid?.trim())}
                          disabled={Submitted}
                          style={{
                            backgroundColor: soilLoading?.includes(option?.Guid?.trim())
                              ? mode === 'dark'
                                ? Color.BG_DARK
                                : Color.BG_LIGHT
                              : '#9A9A9A',
                            borderColor: soilLoading?.includes(option?.Guid?.trim())
                              ? mode === 'dark'
                                ? Color.BG_DARK
                                : Color.BG_LIGHT
                              : '#9A9A9A',
                          }}
                        />
                        <label>{option?.Name} </label>
                      </div>
                    ) : (
                      ''
                    )
                  })}
                </div>
              </div>

              <div
                style={{flex: 10}}
                className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'
              >
                <div style={{flex: 0.4}}>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'UNLOADING_ON_FLOORS'})}
                  </label>
                  ({' '}
                  <i className='fa fa-star-of-life text-danger' style={{fontSize: 10, top: -5}}></i>{' '}
                  )
                </div>
                <div className='d-flex gap-10 my-3' style={{flex: 0.6}}>
                  {dropdownChargementDataTB.map((options, index) =>
                    serviceT006?.MB500Selected === false ||
                    (serviceT006?.MB500Selected === true && options?.Name !== 'Latéral') ? (
                      <div key={index} className='d-flex gap-3 align-items-center'>
                        <input
                          data-bs-theme={mode}
                          className={'form-check-input fs-3 '}
                          type='checkbox'
                          disabled={Submitted}
                          onChange={async (e) => {
                            const checked = e.target.checked
                            onChangeUnloadingOnFloors(checked, index, options)
                          }}
                          checked={unloadingOnFloors?.includes(options?.Guid?.trim())}
                          style={{
                            backgroundColor: unloadingOnFloors?.includes(options?.Guid?.trim())
                              ? mode === 'dark'
                                ? Color.BG_DARK
                                : Color.BG_LIGHT
                              : '#9A9A9A',
                            borderColor: unloadingOnFloors?.includes(options?.Guid?.trim())
                              ? mode === 'dark'
                                ? Color.BG_DARK
                                : Color.BG_LIGHT
                              : '#9A9A9A',
                          }}
                        />
                        <label>{options?.Name}</label>
                      </div>
                    ) : (
                      ''
                    )
                  )}
                </div>
              </div>

              <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'>
                <div style={{flex: 0.4}}>
                  <label className='fs-4 text-gray-700' style={{flex: 0.4}}>
                    {intl.formatMessage({id: 'MESSAGE_FACADE_ASBESTOS'})}{' '}
                  </label>
                  {serviceT006?.IsThefacadeAsbestos === true ? (
                    <p style={{marginTop: '10px', color: 'red'}}>
                      {intl.formatMessage({id: 'MESSAGE_PLOTS'})}
                    </p>
                  ) : (
                    ''
                  )}
                </div>
                <div className='d-flex gap-10 mb-5' style={{flex: 0.6}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT006?.IsThefacadeAsbestos === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT006({...serviceT006, IsThefacadeAsbestos: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT006?.IsThefacadeAsbestos === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT006({...serviceT006, IsThefacadeAsbestos: false})
                    }}
                  />
                </div>
              </div>

              <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'>
                <div style={{flex: 0.4}}>
                  <label className='fs-4 text-gray-700'>
                    {intl.formatMessage({id: 'MESSAGE_CLADDING_FACADE'})}{' '}
                  </label>
                  {serviceT006?.AnyCladdingOnTheFacade === true ? (
                    <p style={{marginTop: '10px', color: 'red'}}>
                      {intl.formatMessage({id: 'MESSAGE_FRONT'})}
                    </p>
                  ) : (
                    ''
                  )}
                </div>

                <div className='d-flex gap-10 mb-5' style={{flex: 0.6}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT006?.AnyCladdingOnTheFacade === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT006({...serviceT006, AnyCladdingOnTheFacade: true})
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT006?.AnyCladdingOnTheFacade === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      setServiceT006({...serviceT006, AnyCladdingOnTheFacade: false})
                    }}
                  />
                </div>
              </div>

              {!Submitted && (
                <div className='d-flex gap-5 justify-content-end my-5'>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      className='btn btn-dark'
                      disabled={isDisabled}
                      onClick={() => {
                        if (!lodash.isEqual(serviceT006, t1init)) {
                          setShowCancel(true)
                        } else {
                          if (inputChange) {
                            setServiceT006({...serviceT006})
                            setInputChange(false)
                          }
                        }
                      }}
                    >
                      {intl.formatMessage({id: 'RESET'})}
                      <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                    </Button>
                  </span>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      type='button'
                      className='btn btn-danger'
                      onClick={handleClickT006}
                      disabled={isDisabled}
                    >
                      {intl.formatMessage({id: 'SAVE'})}
                      <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                    </Button>
                  </span>
                </div>
              )}
            </div>
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToggleButtonForm6
